import { render } from "./LoadingAnimator.vue?vue&type=template&id=3c5f0a33&scoped=true"
import script from "./LoadingAnimator.vue?vue&type=script&lang=js"
export * from "./LoadingAnimator.vue?vue&type=script&lang=js"

import "./LoadingAnimator.vue?vue&type=style&index=0&id=3c5f0a33&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c5f0a33"]])

export default __exports__